import Map from 'scripts/models/base/map';

export default Map.extend({
    define: {
        type: {
            type: 'string',
            value: ''
        },
        date: {
            type: 'string',
            value: ''
        }
    },
    init: function (obj) {
        this._super();
        this.isValid = this.checkValidation(obj);
    },
    checkValidation: function (obj) {
        let valid = true;
        _.each(this.define, (val, key) => {
            if (typeof obj[key] === 'undefined') {
                return valid = false;
            }
        });
        return valid;
    }
});